import { SchemaInterface } from '@app/shared/types/schema-interface';

export class SchemaProperties {
  constructor(private schema: SchemaInterface) {}
}
